import type {Context} from '../types';
import type {JSONNode} from '@packages/shared/types/JSONNode';

const uniqueSymbolName = (
  jsonNodes: Array<JSONNode>,
  increment: number
): string => {
  const symbolName = `Symbol ${increment}`;
  const foundExistingName = jsonNodes.some(
    (node) => node.data && node.data.sym && node.data.sym.name === symbolName
  );
  if (foundExistingName) {
    return uniqueSymbolName(jsonNodes, increment + 1);
  } else {
    return symbolName;
  }
};

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {jsonNodes},
  } = context;
  const {data = {}} = jsonNode;
  const isSymbolRoot = data.sym && data.sym.root === true;
  const hasUndefinedName =
    data.sym &&
    (data.sym.name === undefined ||
      data.sym.name === null ||
      data.sym.name === '');

  return {
    needed: isSymbolRoot && hasUndefinedName,
    logData: {
      msg: 'Symbols need to have a defined name',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.sym.name = uniqueSymbolName(jsonNodes, 1);
    },
  };
};
